export const CONSTANTS = {
    APP_VERSION: '1.1.4.3'
}